import countryList from "@paywallRoot/countries/country-list";

export const countryOptions = [...countryList]
  .sort((c1, c2) => c1.countryName.localeCompare(c2.countryName))
  .map((c) => ({ value: c.countryCode, label: c.countryName }));
